import React, { createContext, useContext, FC } from 'react';
import { useUrlParams } from 'clientState/hooks/useUrlParams';
import { useGetLocations } from 'clientState/hooks/useGetLocations/useGetLocations';
import { useGetLocationRequest } from './hooks';
import { GeoServiceLocation } from 'generated/graphql';
import { usePerformedSemSearchHash } from 'clientState/providers/SEM/SemSearchRequestHashProvider';

type SemLocationsContextType = {
  locations: Record<string, GeoServiceLocation>;
};

const SemLocationsContext = createContext<SemLocationsContextType>({
  locations: {},
});

const SemLocationsProvider: FC = ({ children }) => {
  const hash = usePerformedSemSearchHash();
  const urlParams = useUrlParams(hash);
  const locationsRequest = useGetLocationRequest(urlParams);
  const locations = useGetLocations(
    locationsRequest,
    !window.location.href.includes('bestprices')
  );

  return (
    <SemLocationsContext.Provider value={{ locations }}>
      {children}
    </SemLocationsContext.Provider>
  );
};

export const useSemLocations = (): SemLocationsContextType =>
  useContext(SemLocationsContext);

export default SemLocationsProvider;
